import { Link } from "react-router-dom";
import axios from 'axios'

import '../App.css';
import { FormattedMessage  } from 'react-intl';
import { getCurrencySymbol, formatBytes, compareStrings, isColorToString, isDuplexToString, drawSupply } from '../utils/utils';
import { PRINTERS_PATH, USERS_PATH, COMPUTERS_PATH, USERS_GROUPS_PATH, COMPUTERS_GROUPS_PATH } from "../utils/constants";

export function getServerDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="DeviceMetersTable.name"/>,
        dataIndex: 'prnName',
        
        width: '300px',
        sorter: {
            compare: (a, b) => compareStrings(a.prnName, b.prnName)
        },
        search: true,
        render: (_, record) => {
            const url = PRINTERS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.prnName}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="SuppliesTable.location"/>,
            dataIndex: 'prnLocation',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.prnLocation, b.prnLocation)
            },   
        },
        {
            title: <FormattedMessage id="SuppliesTable.comment"/>,
            dataIndex: 'prnComment',
               
            search: true,      
            sorter: {
                compare: (a, b) => compareStrings(a.prnComment, b.prnComment)
            },          
        },
        {
            title: <FormattedMessage id="HardwareTable.serial"/>,
            dataIndex: 'serialNumber',
               
            search: true,             
        },
        {
            title: <FormattedMessage id="Users"/>,
            dataIndex: 'users',
            
            sorter: {
            compare: (a, b) => a.users - b.users,
            },
        },
        {
            title: <FormattedMessage id="Computers"/>,
            dataIndex: 'computers',
            
            sorter: {
            compare: (a, b) => a.computers - b.computers,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
        {
            title: <FormattedMessage id="Size"/>,
            dataIndex: 'jobSize',
             
            sorter: {
            compare: (a, b) => a.jobSize - b.jobSize,
            },
            render: (_, record) =>
            <div>
                {formatBytes(record.jobSize === undefined ? 0 : record.jobSize)}
            </div>
            ,
        },
    ];
}

export function getPrintersDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="DeviceMetersTable.name"/>,
        dataIndex: 'name',
        
        width: '300px',
        sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
        },
        search: true,
        render: (_, record) => {
            const url = PRINTERS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="Users"/>,
            dataIndex: 'users',
            
            sorter: {
            compare: (a, b) => a.users - b.users,
            },
        },
        {
            title: <FormattedMessage id="Computers"/>,
            dataIndex: 'computers',
            
            sorter: {
            compare: (a, b) => a.computers - b.computers,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="ColorDocuments"/>,
            dataIndex: 'colorDocuments',
            
            sorter: {
            compare: (a, b) => a.colorDocuments - b.colorDocuments,
            },
        },
        {
            title: <FormattedMessage id="BWDocuments"/>,
            dataIndex: 'blackDocuments',
            
            sorter: {
            compare: (a, b) => a.blackDocuments - b.blackDocuments,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="BWPages"/>,
            dataIndex: 'blackPages',
            
            sorter: {
            compare: (a, b) => a.blackPages - b.blackPages,
            },
        },
        {
            title: <FormattedMessage id="ColorPages"/>,
            dataIndex: 'colorPages',
            
            sorter: {
            compare: (a, b) => a.colorPages - b.colorPages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
    ];
}

export function getPrinterDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="User"/>,
        dataIndex: 'userName',
        
        width: '200px',
        sorter: {
            compare: (a, b) => compareStrings(a.userName, b.userName)
        },
        search: true,
        render: (_, record) => {
            const url = USERS_PATH + "/" + record.userId;
            return(
            <div>
                <Link to={url}>{record.userName}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="Document"/>,
            dataIndex: 'name',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.name, b.name)
            },
            render: (_, record) => {
                if (record.jobDataType === 1 && record.jobDataSize > 0)
                {
                    const url = axios.defaults.baseURL + "/job_data/" + record.id;
                    return(
                    <div>
                        <a href={url}>{record.name}</a>
                    </div>
                    );
                }
                else
                {
                    return(
                        <div>{record.name}</div>
                        );    
                }
            },
        },
        {
            title: <FormattedMessage id="Printer"/>,
            dataIndex: 'prnName',
            
            width: '10%',
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.prnName, b.prnName)
            },
            render: (_, record) => {
                const url = PRINTERS_PATH + "/" + record.printerId;
                return(
                <div>
                    <Link to={url}>{record.prnName}</Link>
                </div>
                );
            }   
        },
        {
            title: <FormattedMessage id="Computer"/>,
            dataIndex: 'compName',
            
            search: true,
            sorter: {
                compare: (a, b) => compareStrings(a.compName, b.compName)
            },
            render: (_, record) => {
                const url = COMPUTERS_PATH + "/" + record.computerId;
                return(
                <div>
                    <Link to={url}>{record.compName}</Link>
                </div>
                );
            }   
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
        {
            title: <FormattedMessage id="Size"/>,
            dataIndex: 'jobSize',
            
            sorter: {
            compare: (a, b) => a.jobSize - b.jobSize,
            },
            render: (_, record) =>
                <div>
                    {formatBytes(record.jobSize === undefined ? 0 : record.jobSize)}
                </div>
        },
        {
            title: <FormattedMessage id="Color"/>,
            dataIndex: 'color',        
            key: 'color',
            sorter: {
                compare: (a, b) => a.color - b.color,
            },
            filters: [
                { text: <FormattedMessage id="Yes"/>, value: 1 },
                { text: <FormattedMessage id="No"/>, value: 0 },
              ],
            filterMultiple: false,
            onFilter: (value, record) => {
                if (value === 1) {
                    return record.color === 2;
                }
                else if (value === 0) {
                    return record.color === 1;
                }
                else {
                    return true;
                }
            },
            render: (_, record) =>
            <div>
                <FormattedMessage id={isColorToString(record.color)}/>
            </div>
        },
        {
            title: <FormattedMessage id="Duplex"/>,
            dataIndex: 'duplex',
            key: 'duplex', 
            sorter: {
                compare: (a, b) => a.duplex - b.duplex,
            },
            filters: [
                { text: <FormattedMessage id="Yes"/>, value: 1 },
                { text: <FormattedMessage id="No"/>, value: 0 },
              ],
            filterMultiple: false,
            onFilter: (value, record) => {
                if (value === 1) {
                    return record.duplex > 1;
                }
                else if (value === 0) {
                    return record.duplex === 1;
                }
                else {
                    return true;
                }
            },
            render: (_, record) =>
            <div>
                <FormattedMessage id={isDuplexToString(record.duplex)}/>
            </div>
        },
        {
            title: <FormattedMessage id="PaperName"/>,
            dataIndex: 'paperName',
                            
            sorter: {
                compare: (a, b) => compareStrings(a.paperName, b.paperName)
            },
            search: true,
        },
        {
            title: <FormattedMessage id="Data"/>,
            dataIndex: 'submitDate',
             
            width:150,               
            sorter: {
              compare: (a, b) => 
              {
                  const time_a = Date.parse(a.submitDate);
                  const time_b = Date.parse(b.submitDate);
                  return time_a - time_b;
              }
            },
            search: true,
            render: (_, record) =>
            <div>
                {record.submitDate !== undefined && new Date(record.submitDate).toLocaleString(navigator.language || navigator.userLanguage)}
            </div>
        },        
    ];
}

export function getUsersDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="Username"/>,
        dataIndex: 'name',
        
        width: '100px',
        sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
        },
        search: true,
        render: (_, record) => {
            const url = USERS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="DeviceMetersTable.name"/>,
            dataIndex: 'fullname',
            
            width: '200px',
            sorter: {
                compare: (a, b) => compareStrings(a.fullname, b.fullname)
            },
            search: true,
            render: (_, record) => {
                const url = USERS_PATH + "/" + record.id;
                return(
                <div>
                    <Link to={url}>{record.fullname}</Link>
                </div>
                );
            }   
        },
        {
            title: <FormattedMessage id="Printers"/>,
            dataIndex: 'printers',
            
            sorter: {
            compare: (a, b) => a.printers - b.printers,
            },
        },
        {
            title: <FormattedMessage id="Computers"/>,
            dataIndex: 'computers',
            
            sorter: {
            compare: (a, b) => a.computers - b.computers,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="ColorDocuments"/>,
            dataIndex: 'colorDocuments',
            
            sorter: {
            compare: (a, b) => a.colorDocuments - b.colorDocuments,
            },
        },
        {
            title: <FormattedMessage id="BWDocuments"/>,
            dataIndex: 'blackDocuments',
            
            sorter: {
            compare: (a, b) => a.blackDocuments - b.blackDocuments,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="BWPages"/>,
            dataIndex: 'blackPages',
            
            sorter: {
            compare: (a, b) => a.blackPages - b.blackPages,
            },
        },
        {
            title: <FormattedMessage id="ColorPages"/>,
            dataIndex: 'colorPages',
            
            sorter: {
            compare: (a, b) => a.colorPages - b.colorPages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
    ];
}

export function getUsersGroupsDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="DeviceMetersTable.name"/>,
        dataIndex: 'name',
        
        width: '200px',
        sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
        },
        search: true,
        render: (_, record) => {
            const url = USERS_GROUPS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="Workload"/>,
            dataIndex: 'id',
            
            render: (_, record) => {
                return(drawSupply({level: record.workload, maxCapacity: 100, color: "lawngreen"}));
              }   
        },
        {
            title: <FormattedMessage id="SuppliesChangesTable.description"/>,
            dataIndex: 'description',
            
            width: '200px',
            sorter: {
                compare: (a, b) => compareStrings(a.description, b.description)
            },
            search: true  
        },
        {
            title: <FormattedMessage id="Printers"/>,
            dataIndex: 'printers',
            
            sorter: {
            compare: (a, b) => a.printers - b.printers,
            },
        },
        {
            title: <FormattedMessage id="Users"/>,
            dataIndex: 'users',
            
            sorter: {
            compare: (a, b) => a.users - b.users,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="ColorDocuments"/>,
            dataIndex: 'colorDocuments',
            
            sorter: {
            compare: (a, b) => a.colorDocuments - b.colorDocuments,
            },
        },
        {
            title: <FormattedMessage id="BWDocuments"/>,
            dataIndex: 'blackDocuments',
            
            sorter: {
            compare: (a, b) => a.blackDocuments - b.blackDocuments,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="BWPages"/>,
            dataIndex: 'blackPages',
            
            sorter: {
            compare: (a, b) => a.blackPages - b.blackPages,
            },
        },
        {
            title: <FormattedMessage id="ColorPages"/>,
            dataIndex: 'colorPages',
            
            sorter: {
            compare: (a, b) => a.colorPages - b.colorPages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
    ];
}

export function getComputersGroupsDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="DeviceMetersTable.name"/>,
        dataIndex: 'name',
        
        width: '200px',
        sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
        },
        search: true,
        render: (_, record) => {
            const url = COMPUTERS_GROUPS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="Workload"/>,
            dataIndex: 'id',
            
            render: (_, record) => {
                return(drawSupply({level: record.workload, maxCapacity: 100, color: "lawngreen"}));
              }   
        },
        {
            title: <FormattedMessage id="SuppliesChangesTable.description"/>,
            dataIndex: 'description',
            
            width: '200px',
            sorter: {
                compare: (a, b) => compareStrings(a.description, b.description)
            },
            search: true  
        },
        {
            title: <FormattedMessage id="Printers"/>,
            dataIndex: 'printers',
            
            sorter: {
            compare: (a, b) => a.printers - b.printers,
            },
        },
        {
            title: <FormattedMessage id="Computers"/>,
            dataIndex: 'computers',
            
            sorter: {
            compare: (a, b) => a.computers - b.computers,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="ColorDocuments"/>,
            dataIndex: 'colorDocuments',
            
            sorter: {
            compare: (a, b) => a.colorDocuments - b.colorDocuments,
            },
        },
        {
            title: <FormattedMessage id="BWDocuments"/>,
            dataIndex: 'blackDocuments',
            
            sorter: {
            compare: (a, b) => a.blackDocuments - b.blackDocuments,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="BWPages"/>,
            dataIndex: 'blackPages',
            
            sorter: {
            compare: (a, b) => a.blackPages - b.blackPages,
            },
        },
        {
            title: <FormattedMessage id="ColorPages"/>,
            dataIndex: 'colorPages',
            
            sorter: {
            compare: (a, b) => a.colorPages - b.colorPages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
    ];
}

export function getComputersDetailedColumns()
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
        title: <FormattedMessage id="Computer"/>,
        dataIndex: 'name',
        
        width: '100px',
        sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
        },
        search: true,
        render: (_, record) => {
            const url = COMPUTERS_PATH + "/" + record.id;
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
        }   
        },
        {
            title: <FormattedMessage id="Printers"/>,
            dataIndex: 'printers',
            
            sorter: {
            compare: (a, b) => a.printers - b.printers,
            },
        },
        {
            title: <FormattedMessage id="Users"/>,
            dataIndex: 'users',
            
            sorter: {
            compare: (a, b) => a.users - b.users,
            },
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
            compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="ColorDocuments"/>,
            dataIndex: 'colorDocuments',
            
            sorter: {
            compare: (a, b) => a.colorDocuments - b.colorDocuments,
            },
        },
        {
            title: <FormattedMessage id="BWDocuments"/>,
            dataIndex: 'blackDocuments',
            
            sorter: {
            compare: (a, b) => a.blackDocuments - b.blackDocuments,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
            compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="BWPages"/>,
            dataIndex: 'blackPages',
            
            sorter: {
            compare: (a, b) => a.blackPages - b.blackPages,
            },
        },
        {
            title: <FormattedMessage id="ColorPages"/>,
            dataIndex: 'colorPages',
            
            sorter: {
            compare: (a, b) => a.colorPages - b.colorPages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
            compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
    ];
}
